// 获取TN的名字
export const getLevel = val => {
  let el = ''
  switch (val) {
    case 'value_er':
    case 'value_liang':
    case 'decimal_er':
    case 'decimal_liang':
    case 'value_er_ignore_tail':
    case 'value_liang_ignore_tail':
    case 'value':
      el = '数值'
      break
    case 'digit_yi':
    case 'digit_yao':
      el = '序列'
      break
    case 'date':
      el = '日期'
      break
    case 'scale':
      el = '范围'
      break
    case 'math':
      el = '算数'
      break
    case 'telephone':
      el = '电话'
      break
    case 'time':
      el = '时间'
      break
    case 'ratio':
      el = '比分'
      break
    case 'fraction':
      el = '分数'
      break
    case 'english':
      el = '英语'
      break
    case 'mandarin':
      el = '中文'
      break
    case 'alphabet':
      el = '字母'
      break
    case 'word':
      el = '单词'
      break
    case 'precent_numer':
      el = '百分数'
      break
    case 'website':
      el = '网址[英]'
      break
    case 'mandarin_website':
      el = '网址[中]'
      break
    case 'currency':
      el = '货币'
      break
    case 'coordinate':
      el = '坐标'
      break
    case 'temperature':
      el = '温度'
      break
    case 'stock':
      el = '股票'
      break
    default:
      if (val.includes('now_')) {
        el = `${val.replace('now_', '读法')}`
      } else {
        el = '读法'
      }
  }
  return el
}